import { useGetExtendedProfile } from './hooks/useGetExtendedProfile'
import { MemberProfileExtended } from '../../cwp-components/CWP Sections/MemberProfile/Extended/MemberProfileExtended'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { MemberEntityTypeKey } from 'common/types/MemberProfile'

export const MemberProfileExtendedPage = () => {
  const [reloadKey, setReloadKey] = useState(0)

  const { identity, memberEntity } = useParams<{
    identity: string
    memberEntity: MemberEntityTypeKey
  }>()
  // Extract friendly_id from the last part of the identity
  const friendly_id = identity.split('-').pop()

  const { extendedProfile } = useGetExtendedProfile({
    id: friendly_id,
    memberEntity,
    reloadKey,
  })

  const reloadProfile = () => {
    setReloadKey((prev) => prev + 1); // Incrementing to trigger refetch
  };

  return <MemberProfileExtended profile={extendedProfile} reloadProfile={reloadProfile} />
}
